import { useContext, useState } from 'react';
import * as React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import AuthContext from '../../context/auth/authContext';
import Login from '@mui/icons-material/ExitToApp';
import Logout from '@mui/icons-material/Logout';
import Home from '@mui/icons-material/Home';
import DescriptionIcon from '@mui/icons-material/Description';
import Register from '@mui/icons-material/AppRegistration';
import Shop from '@mui/icons-material/AddBusiness';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import { useNavigate } from 'react-router-dom';
import Typography from '@mui/material/Typography';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import MenuItem from '@mui/material/MenuItem';
import styled from 'styled-components';
import AccountCircle from '@mui/icons-material/AccountCircle';
import ListIcon from '@mui/icons-material/List';
import breakpoints from '../../essentials/screensize';
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';
import PaidSharpIcon from '@mui/icons-material/PaidSharp';
//importing image
import Logo from '../../assets/logo.png';

import CssBaseline from '@mui/material/CssBaseline';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';

import Button from '@mui/material/Button';

const LogoIcon = styled.div`
.logo{width: 4.5vw;
margin-top: 0.7vh;
padding: 0.3rem;
    @media (max-width: ${breakpoints.sm}px) {
      width: 3.5rem;
      margin-top: 0.5rem;
      padding: 0.3rem;
    }
  }}
`;

const Navbar = ({ icon }) => {
    const authContext = useContext(AuthContext);

    const { isAuthenticated, logout, user, loadUser } = authContext;
    const [anchorElNav, setAnchorElNav] = useState(null);
    let navigate = useNavigate();
    const onLogout = () => {
        logout();
        navigate({ pathname: '/login' });
    };
    const handleOpenNavMenu = (event) => {
        setAnchorElNav(event.currentTarget);
    };
    const handleCloseNavMenu = () => {
        setAnchorElNav(null);
    };
    const drawerWidth = 240;
    const navItems = ['Home', 'About', 'Contact'];

    const [mobileOpen, setMobileOpen] = React.useState(false);

    const handleDrawerToggle = () => {
        setMobileOpen((prevState) => !prevState);
    };

    const authLinks = (
        <>
            <Link to="/">
                <IconButton size="large" aria-label="account of current user">
                    {/* <AccountCircle /> */}
                    <PaidSharpIcon />

                    <Typography variant="body2" align="center">
                        {/* {user && user.name} */}
                        Payments
                    </Typography>
                </IconButton>
            </Link>
            <Link to="/allclients">
                <IconButton
                    size="large"
                    aria-label="Clientform"
                    style={{ color: 'grey' }}
                >
                    <ListIcon />
                    <Typography variant="body2" align="center">
                        All Clients
                    </Typography>
                </IconButton>
            </Link>
            <Link to="/clientform">
                <IconButton
                    size="large"
                    aria-label="Clientform"
                    style={{ color: 'grey' }}
                >
                    <DescriptionIcon />
                    <Typography variant="body2" align="center">
                        Client Form
                    </Typography>
                </IconButton>
            </Link>
            <IconButton
                size="large"
                onClick={onLogout}
                aria-label="logout"
                style={{ color: 'grey' }}
            >
                <Logout />
                <Typography variant="body2" align="center">
                    Logout
                </Typography>
            </IconButton>
        </>
    );

    const guestLinks = (
        <>
            {/* <Link to="/">
                <IconButton
                    size="large"
                    aria-label="aboutus"
                    style={{ color: 'grey' }}
                >
                    <BusinessCenterIcon />
                    <Typography variant="body2" align="center">
                        About Us
                    </Typography>
                </IconButton>
            </Link> */}
            <Link to="/">
                <IconButton
                    size="large"
                    aria-label="login"
                    style={{ color: 'grey' }}
                >
                    <Login />
                    <Typography variant="body2" align="center">
                        Login
                    </Typography>
                </IconButton>
            </Link>
            <Link to="/register">
                <IconButton
                    size="large"
                    aria-label="register"
                    style={{ color: 'grey' }}
                    label="Register"
                >
                    <Register />
                    <Typography variant="body2" align="center">
                        Register
                    </Typography>
                </IconButton>
            </Link>
        </>
    );
    const drawer = (
        <Box onClick={handleDrawerToggle} sx={{ textAlign: 'center' }}>
            <LogoIcon>
                <Link to="/">
                    <img
                        src={icon}
                        alt="payment-solution"
                        className="logo"
                    ></img>
                </Link>
            </LogoIcon>

            <Divider />
            <List>{isAuthenticated ? authLinks : guestLinks}</List>
        </Box>
    );

    return (
        <>
            <Box sx={{ display: 'flex', backgroundColor: 'white' }}>
                <AppBar component="nav" style={{ background: 'white' }}>
                    <Toolbar>
                        <IconButton
                            color="inherit"
                            aria-label="open drawer"
                            edge="start"
                            onClick={handleDrawerToggle}
                            sx={{ mr: 2, display: { sm: 'none' } }}
                        >
                            <MenuIcon style={{ color: 'black' }} />
                        </IconButton>

                        <Typography
                            sx={{
                                flexGrow: 1,
                                display: { xs: 'none', sm: 'block' }
                            }}
                        >
                            <LogoIcon
                                variant="h6"
                                component="div"
                                sx={{
                                    flexGrow: 1,
                                    display: { xs: 'none', sm: 'block' }
                                }}
                            >
                                <Link to="/">
                                    <img
                                        src={icon}
                                        alt="payment-solution"
                                        className="logo"
                                    ></img>
                                </Link>
                            </LogoIcon>
                        </Typography>
                        <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
                            {isAuthenticated ? authLinks : guestLinks}
                        </Box>
                    </Toolbar>
                </AppBar>
                <Box component="nav">
                    <Drawer
                        variant="temporary"
                        open={mobileOpen}
                        onClose={handleDrawerToggle}
                        ModalProps={{
                            keepMounted: true // Better open performance on mobile.
                        }}
                        sx={{
                            display: { xs: 'block', sm: 'none' },
                            '& .MuiDrawer-paper': {
                                boxSizing: 'border-box',
                                width: drawerWidth
                            }
                        }}
                    >
                        {drawer}
                    </Drawer>
                </Box>
            </Box>
        </>
    );
};

Navbar.propTypes = {
    icon: PropTypes.string
};

Navbar.defaultProps = {
    icon: Logo
};

export default Navbar;
